import React, { useCallback } from "react";
import { Box } from "@mui/material";
import { InputButton } from "components/UI";
//UTIL
import { responseErrors, messageDisplay, isBlankOrNull } from "utils";
import { BUTTON_VALUE } from "shared/constants";
// Hook
import { useConfirmDialogContext } from "context/confirmDialogContext";
import { ModeAction } from "state/enum";
import { simulateGraph } from "../hooks/format";
//Constant
import { MSG_TYPE } from "state/enum";
//Service
import { deepClone } from "@mui/x-data-grid/utils/utils";

export default function ButtonGraph(props) {
  const {
    form,
    defaultGraphData,
    setDefaultGraph,
    graphData,
    setGraph,
    setMode,
    setOnSearch,
    setOpenGraph,
    defaultRows,
    setRows,
    getWarehouse,
    rPkg,
    isLoadingView,
    loading: { startLoading, stopLoading },
    stateBtn: { simulateBtn, cancelBtn, setGeneratedGraph, generatedGraph },
    setMsg: { setMsgAlert, setMsgError },
    dataList: { rPackageOwnerList, rPackageTypeList },
    rowSelection: { rowModesModel, setRowModesModel, rowSelectionModel, setRowSelectionModel },
    rowsChanged,
    functionId,
    rows,
  } = props;
  const confirmDialogCtx = useConfirmDialogContext();
  const handleSimulate = useCallback(async () => {
    try {
      setMsgError([]);
      setMsgAlert([]);
      const checkAllocateDtNull = rowsChanged.filter(row => row.plantId !== "" && row.allocateDt === null);
      if (checkAllocateDtNull.length > 0) {
        let msg;
        //! validate required field
        if (checkAllocateDtNull.length > 0) {
          checkAllocateDtNull.forEach(row => {
            msg = messageDisplay({
              type: MSG_TYPE.ERROR,
              code: "MDN96008AERR",
              msg: [`Row ${row?.rowNumber}`, `Container ${row?.containerNo}`, "Allocation Date and Warehouse"],
            });
            setMsgError(prev => [...prev, [msg]]);
            window.scroll(0, 0);
          });
        }
        return;
      }
      if (!isBlankOrNull(defaultGraphData) && rowsChanged?.length === 0) {
        // const simulateData = simulateGraph(defaultGraphData, rowsChanged, rPkg, true);
        // setGraph(simulateData);
        setOpenGraph(true);
        return;
      }

      if (!isBlankOrNull(defaultGraphData)) {
        const simulateData = simulateGraph(defaultGraphData, rowsChanged, rPkg, false);
        setGraph(simulateData);
        setOpenGraph(true);
        return;
      }

      setMsgError(["MSTD0061AERR: No data to be displayed graph"]);
      setGraph({});
      setDefaultGraph({});
      setOpenGraph(false);

      return;
    } catch (error) {
      console.error(error);
      const errors = responseErrors(error);
      setMsgError(errors);
      return;
    }
  }, [defaultGraphData, rPkg, rowSelectionModel, setGraph, setMsgAlert, setMsgError, setOpenGraph]);

  const handleCancel = async () => {
    try {
      //reset
      setMsgAlert([]);
      setMsgError([]);
      const allocateConfirm = await confirmDialogCtx.success({
        type: "INVENTORY_CONFIRM_CANCEL",
      });
      if (!allocateConfirm) {
        return;
      }

      setMode(ModeAction.VIEW);
      setRowSelectionModel([]);
      setRowModesModel({});
      setRows(deepClone(defaultRows));
      setGraph(deepClone(defaultGraphData));
      setOnSearch(true);
    } catch (error) {
      const errors = responseErrors(error);
      setMsgError(errors);
      return;
    }
  };

  return (
    <Box>
      <InputButton
        id="button-simulate"
        value={"Simulate"}
        disabled={simulateBtn || isLoadingView || generatedGraph}
        onClick={handleSimulate}
        name={`${functionId}Simulate`}
        tabIndex={1}
      />
      <InputButton
        id="button-cancel"
        value={BUTTON_VALUE.CANCEL}
        disabled={cancelBtn}
        onClick={handleCancel}
        name={`${functionId}Cancel`}
        tabIndex={1}
      />
    </Box>
  );
}
